// ------------ header background color --------------

// Select the header element
const header = document.querySelector('.header-custom');

// Check if the current page is a product page
const isProductPage = window.location.pathname.includes('/products/');

// Function to handle the scroll event
function handleScroll() {
    if (isProductPage) {
        // Always add 'scrolled' class on product pages
        header.classList.add('scrolled');
    } else {
        // Add or remove the 'scrolled' class based on scroll position
        if (window.scrollY > 0) {
            header.classList.add('scrolled');
        } else {
            header.classList.remove('scrolled');
        }
    }
}

// Initial check to apply the class on page load
if (isProductPage) {
    header.classList.add('scrolled');
}

// Listen to the scroll event
window.addEventListener('scroll', handleScroll);



// ------------ header background color --------------




// ----------------------- custom-search-box ---------------------------------

function toggleSearchBox() {
  const searchBox = document.querySelector('.custom-search-box');
  
  // Toggle the 'active' class to slide the box in and out
  searchBox.classList.toggle('active');
}

// ----------------------- custom-search-box ---------------------------------


// ---------- mobile menu open/close -------

function togglemobilemenu() {
  const mobileMenu = document.querySelector('.mobile-menubox');
  const menuToggle = document.getElementById('menuToggle');

  mobileMenu.classList.toggle('active');

  if (mobileMenu.classList.contains('active')) {
    menuToggle.textContent = 'CLOSE';
  } else {
    menuToggle.textContent = 'MENU';
  }
}


// ---------- mobile menu open/close -------

// ------- remove top marquee from hero page ------

// document.addEventListener("DOMContentLoaded", () => {
//     // Check if the current viewport is mobile and on the hero page
//     if (window.innerWidth <= 950) {
//         const isHeroPage = document.querySelector(".hero-section");

//         if (isHeroPage) {
//             const marqueeElement = document.querySelector(".r-marquee");

//             if (marqueeElement) {
//                 marqueeElement.style.display = "none";
//             }
//         }
//     }
// });


// ------- remove top marquee from hero page ------


// ------------- marquee sticky on hero page --------------


// ------------------------------------------------ new code addded 24-12---------------

// Select the marquee element
const headerMarquee = document.querySelector('.r-marquee');
const heroSection = document.querySelector('.hero-section-main');

// Function to check if the hero section is in the viewport
function isHeroSectionInViewport() {
    const rect = heroSection.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
}

// Function to handle the scroll event
function handleMarqueeScroll() {
    // Check for mobile screen (width less than 950px)
    if (window.innerWidth < 950) {
        // Apply transition for smooth opacity changes
        headerMarquee.style.transition = 'opacity 0.3s ease-in'; // Ensure the transition is smooth

        // If the hero section is in the viewport, hide .r-marquee
        if (isHeroSectionInViewport()) {
            headerMarquee.style.opacity = '0'; // Hide .r-marquee
        } else {
            headerMarquee.style.opacity = '1'; // Show .r-marquee
        }
    } else {
        // On larger screens, ensure .r-marquee is visible
        headerMarquee.style.opacity = '1';
    }
}

// Add scroll event listener for marquee visibility
window.addEventListener('scroll', handleMarqueeScroll);

// Initial check to set visibility on page load
handleMarqueeScroll();



// ------------------------------------------------ new code addded 24-12---------------


// ------------- marquee sticky on hero page --------------


// ============= waitlist popup ================================

function openPopup() {
    document.getElementById("overlay").style.display = "flex";
    document.addEventListener("keydown", handleKeyDown);

    // Add click event listener to the overlay
    document.getElementById("overlay").addEventListener("click", closePopup);
}

function closePopup(event) {
    if (event.type === "click" || event.key === "Escape") {
        // Check if the click is on the overlay itself, not the popup content
        if (event.type === "click" && event.target === document.getElementById("overlay")) {
            document.getElementById("overlay").style.display = "none";
            document.removeEventListener("keydown", handleKeyDown);
            document.getElementById("overlay").removeEventListener("click", closePopup);
        }
        // Handle the Escape key press
        else if (event.key === "Escape") {
            document.getElementById("overlay").style.display = "none";
            document.removeEventListener("keydown", handleKeyDown);
            document.getElementById("overlay").removeEventListener("click", closePopup);
        }
    }
}

function handleKeyDown(event) {
    if (event.key === "Escape") {
        closePopup(event);
    }
}

// ============= waitlist popup ================================

